import React from "react";
import $ from "jquery";
import { notify } from "react-notify-toast";
import Login from "./Login";
import {
  API_REGISTER,
  API_GENDER,
  API_PROGRAM,
  BASE_URL,
  API_INSTITUTE,
} from "../Util";
import { Button, Modal } from "react-materialize";
import RegisterPasswordSmile from "./components/RegisterPasswordSmile";
import FormRegister from "./components/Register";
import { Link } from "react-router-dom";
import Tab from "./components/Tab";

class Register extends Login {
  constructor(props) {
    super(props);
    this.state = {
      type: "smile",
      username_smile: "",
      dataRegister: {},
      params: {},
    };

    this.clientToken = "aa6d8694eea3d1b52aa6e4169b0a822665b56fc4";
  }

  handleSubmitPassword({ password_smile }, e) {
    const { dataRegister } = this.state;
    dataRegister["password_smile"] = password_smile;

    this.setState({ dataRegister });
    this.handleRegister(e, dataRegister, true);
  }

  handleRegister = (e, dataRegister, forceSubmit) => {
    const { type } = this.state;
    let dataTemp = {
      client_token: this.clientToken,
      device_token: "",
    };

    this.setState({ dataRegister });

    if (type == "smile" && !forceSubmit) {
      $("#trigger-modal-password").trigger("click");
      return false;
    }

    dataRegister = { ...dataRegister, ...dataTemp };

    $.post(API_REGISTER, dataRegister)
      .then((data) => {
        if (data.payload) {
          notify.show(
            "Terima kasih sudah mendaftar di Online, Mohon cek email Anda terlebih dahulu untuk aktivasi email.",
            "success"
          );
          this.props.history.push(
            "/login?smile_account=" + (type == "smile" ? 1 : 0)
          );
        } else {
          notify.show("Terdapat kesalahan, silakan coba lagi", "warning");
        }
      })
      .fail((XMLHttpRequest, textStatus, errorThrown) => {
        let response;

        try {
          response = JSON.parse(XMLHttpRequest.responseText);
        } catch (e) {}

        if (response && response.status) {
          if (response.errors) {
            notify.show(response.errors.email[0], "warning");
          } else {
            notify.show(response.message, "warning");
          }
        }
      });
  };

  render() {
    const { type, dataRegister } = this.state;
    return (
      <div className="bg-grey">
        <div className="pt-m pb-l">
          <div className="form-auth bg-white">
            <div className="px-l py-m full-width">
              <div className="center mb-s">
                <img
                  className="form-auth-header-logo"
                  src={BASE_URL + "/img/white-label/logo/SMILE_Logo_HD.png"}
                  width={222}
                />
              </div>

              {/* <Tab active={type} onChange={(type) => this.setState({ type })} /> */}

              {/* <FormRegister type={type} onSubmit={this.handleRegister} /> */}
              <FormRegister type={"smile"} onSubmit={this.handleRegister} />

              <div className="text-center">
                Sudah punya akun SMILE eLearning? Silakan log in
                <Link to="/login">
                  <a style={{ color: "#3EA6DA" }}> di sini</a>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <Modal
          header="Verifikasi akun SMILE"
          trigger={
            <Button
              waves="light"
              id="trigger-modal-password"
              style={{ display: "none" }}
            >
              Open
            </Button>
          }
        >
          <RegisterPasswordSmile
            username_smile={dataRegister.username_smile}
            onSubmit={(val, e) => this.handleSubmitPassword(val, e)}
          />
        </Modal>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/Auth/Register.js